import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-customer-details-dialog',
  templateUrl: './customer-details-dialog.component.html',
  styleUrls: ['./customer-details-dialog.component.scss']
})
export class CustomerDetailsDialogComponent {
  customerForm: FormGroup;
  confirmation = false;
  equipmentData: any;
  priceType: 'daily' | 'monthly' = 'daily';
  totalAmount = 0;

  constructor(
    public dialogRef: MatDialogRef<CustomerDetailsDialogComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.equipmentData = data?.equipmentData;
    this.priceType = data?.selectedPriceType;

    this.customerForm = this.fb.group({
      name: ['', Validators.required],
      phone: ['', [Validators.required, Validators.pattern(/^[0-9]{8,15}$/)]],
      startDate: ['', Validators.required],
      endDate: ['', Validators.required],
    });

    // 👇 Watch for startDate changes
    this.customerForm.get('startDate')?.valueChanges.subscribe((startDate) => {
      this.updateEndDateForMonthly(startDate);
      this.calculateTotalAmount();
    });

    // 👇 Watch for endDate changes
    this.customerForm.get('endDate')?.valueChanges.subscribe(() => {
      this.calculateTotalAmount();
    });
  }

  /** Auto-update end date if monthly is selected */
  updateEndDateForMonthly(startDate: any) {
    if (this.priceType === 'monthly' && startDate) {
      const start = new Date(startDate);
      const end = new Date(start);
      end.setDate(start.getDate() + 30); // ➕ Add 30 days
      this.customerForm.patchValue({ endDate: end }, { emitEvent: false });
    }
  }

  /** Calculate total amount dynamically */
  /** Calculate total amount dynamically */
calculateTotalAmount() {
  const { startDate, endDate } = this.customerForm.value;
  if (!startDate || !endDate) {
    this.totalAmount = 0;
    return;
  }

  const selectedPrice =
    this.priceType === 'daily'
      ? this.equipmentData.dailyRate
      : this.equipmentData.monthlyRate;

  const start = new Date(startDate);
  const end = new Date(endDate);
  let totalAmount = 0;

  if (this.priceType === 'daily') {
    // Count every day including the start day
    const diffTime = end.getTime() - start.getTime();
    const diffDays = Math.floor(diffTime / (1000 * 3600 * 24)) + 1;
    totalAmount = diffDays * selectedPrice;
  } else {
    // 30 days = 1 month logic
    const diffTime = end.getTime() - start.getTime();
    const diffMonths = diffTime / (1000 * 3600 * 24 * 30); // each 30 days = 1 month
    totalAmount = Math.ceil(diffMonths) * selectedPrice; // round up partial months
  }

  this.totalAmount = totalAmount;
}


  submit() {
    if (this.customerForm.valid) {
      this.confirmation = true;
      this.calculateTotalAmount();
    }
  }

  confirmDetails() {
    const selectedPrice =
      this.priceType === 'daily'
        ? this.equipmentData.dailyRate
        : this.equipmentData.monthlyRate;

    this.dialogRef.close({
      ...this.customerForm.value,
      priceType: this.priceType,
      price: selectedPrice,
      totalAmount: this.totalAmount,
      status: 'pending', 
    });
  }

  editDetails() {
    this.confirmation = false;
  }

  cancel() {
    this.dialogRef.close(null);
  }
}
